/**
 * User claims used for authorization throughout the application
 */
export class UserClaims {
    /** Claim that allows users to change their tenant */
    static readonly CanChangeTenantId = "extension_CanChangeTenantId";
}
